export const globalRiskMock: any = {
  data: {
    dimensions: ['AUS', 'BRA', 'FRA', 'ITA', 'USA'],
    categories: [
      {
        name: 'country',
        values: [2.0, 2.0, 1.0, 2.0, 3.0],
        series: [
          {
            name: 'WARNING',
            total: 3.0,
            percentage: 0.3,
            values: [2.0, 0.0, 0.0, 1.0, 0.0]
          },
          {
            name: 'REJECTED',
            total: 3.0,
            percentage: 0.3,
            values: [0.0, 2.0, 0.0, 0.0, 1.0]
          },
          {
            name: 'PASSED',
            total: 4.0,
            percentage: 0.4,
            values: [0.0, 0.0, 1.0, 1.0, 2.0]
          }
        ]
      },
      {
        name: 'country_history',
        values: [1.0, 2.0, 1.0, 2.0, 3.0],
        series: [
          {
            name: 'WARNING',
            total: 2.0,
            percentage: 0.2222222222222222,
            values: [1.0, 0.0, 0.0, 1.0, 0.0]
          },
          {
            name: 'REJECTED',
            total: 3.0,
            percentage: 0.3333333333333333,
            values: [0.0, 2.0, 0.0, 0.0, 1.0]
          },
          {
            name: 'PASSED',
            total: 4.0,
            percentage: 0.4444444444444444,
            values: [0.0, 0.0, 1.0, 1.0, 2.0]
          }
        ]
      },
      {
        name: 'country_incremental_percentage',
        values: [1.0, 0.0, 0.0, 0.0, 0.0],
        series: [
          {
            name: 'WARNING',
            total: 0.5,
            percentage: 0.3,
            values: [1.0, 0.0, 0.0, 0.0, 0.0]
          },
          {
            name: 'REJECTED',
            total: 0.0,
            percentage: 0.3,
            values: [0.0, 0.0, 0.0, 0.0, 0.0]
          },
          {
            name: 'PASSED',
            total: 0.0,
            percentage: 0.4,
            values: [0.0, 0.0, 0.0, 0.0, 0.0]
          }
        ]
      }
    ],
    total: {
      value: 10,
      percentage: 1.1111111111111112
    },
    average: {
      value: 0,
      percentage: -3.0
    }
  },
  context: {
    aggregatorFormat: 'week',
    monitorDataType: 'com.jumio.dashboardpoc.dto.aggregator.CategoryMonitor',
    dimensionDataType: 'java.lang.String',
    seriesDataType: 'java.lang.Double',
    startTime: 1725148800000,
    endTime: 1727654400000,
    historyStartTime: 1722556800000,
    historyEndTime: 1725062400000,
    durationInaggregatorFormat: 3,
    processedStartTime: 1732204836550,
    processedEndTime: 1732204836684,
    processedTime: 134,
    lastUpdatedTimestamp: 1748995200000
  }
};
